import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { select, Store } from '@ngrx/store';

import { InvitesService } from 'src/app/services/invites.service';
import { VouchersService } from 'src/app/services/vouchers.service';
import { environment } from 'src/environments/environment';
import { Voucher } from 'src/app/interfaces/voucher';
import { selectAllInvites, selectInviteMemberCode } from 'src/app/store/selectors/invite.selectors';
import { selectAllVouchers, selectVouchersLoading } from 'src/app/store/selectors/voucher.selectors';
import {
  selectMgmConfigLoading,
  selectVoucherIsActive,
  selectVouchersProvider,
  selectMgmIsActive,
  selectMgmConfig
} from 'src/app/store/selectors/mgm.selectors';
import * as VoucherActions from 'src/app/store/actions/voucher.actions';
import * as InviteActions from 'src/app/store/actions/invite.actions';

const INVITE_URL = environment.INVITE_URL;

@Component({
  selector: 'invitation-page',
  styleUrls: ['./profile.component.scss'],
  templateUrl: './profile.component.html',
  providers: [InvitesService, VouchersService]
})
export class ProfileComponent implements OnInit {

  invites$: Observable<any[]>;
  vouchers$: Observable<Voucher[]>;
  vouchersLoading$: Observable<boolean>;
  voucherProvider$: Observable<any>;
  voucherIsActive$: Observable<boolean>;
  loadingMgmConfig$: Observable<boolean>;
  inviteMemberCode$: Observable<string>;
  mgmIsActive$: Observable<boolean>;
  mgmConfig$: Observable<boolean>;

  vouchersLoading = false;
  mgmConfig;

  constructor(
    private router: Router,
    private store: Store
  ) {
    this.invites$ = this.store.pipe(select(selectAllInvites));
    this.vouchers$ = this.store.pipe(select(selectAllVouchers));
    this.vouchersLoading$ = this.store.pipe(select(selectVouchersLoading));
    this.voucherProvider$ = this.store.pipe(select(selectVouchersProvider));
    this.voucherIsActive$ = this.store.pipe(select(selectVoucherIsActive));
    this.loadingMgmConfig$ = this.store.pipe(select(selectMgmConfigLoading));
    this.mgmConfig$ = this.store.pipe(select(selectMgmConfig));
    this.inviteMemberCode$ = this.store.pipe(select(selectInviteMemberCode));
    this.mgmIsActive$ = this.store.pipe(select(selectMgmIsActive));
  }

  ngOnInit() {
    this.mgmConfig$.subscribe(config => this.mgmConfig = config);
    this.loadingMgmConfig$.subscribe(this.checkConfig);

    this.store.dispatch(VoucherActions.retrieve());
    this.store.dispatch(InviteActions.retrieve());
  }

  getLink(code) {
    return code ? `${INVITE_URL}/${code}` : '';
  }

  get loading() {
    return this.vouchersLoading;
  }

  checkConfig = (loading) => {
    if (!loading && !this.mgmConfig || this.mgmConfig && !this.mgmConfig.isActive) {
      this.router.navigate(['/home']);
    }
  }
}
